import EditStudentDetailsPopup from "./editStudentDetailsPopup"
import OffboardStudentPopup from "./offboardStudentPopup"
import ProgramTransferStudentPopup from "./transferStudentPopups/programTransferStudentPopup"
import ClassTransferStudentPopup from "./transferStudentPopups/classTransferStudentPopup"
import EditStudentMentorPopup from "./editStudentMentorPopup"
import EditStudentCareerSuccessAdvisorPopup from "./editStudentCareerSuccessAdvisorPopup"
import EditStudentDatacampCredentialsPopup from "./editStudentDatacampCredentialsPopup"
import { EditRegistrationLanguagePopup } from "./transferStudentPopups/editRegistrationLanguagePopup"
import RegisterStudentToCourseClassPopup from "./registerStudentToCourseClassPopup"
import UnregisterStudentFromCourseClassPopup from "./unregisterStudentFromCourseClassPopup"
import UnlockNextWeekPopup from "./unlockNextWeekPopup"
import EditUserFeatureFlagsDialog from "../../../account-management/editUserFeatureFlagsDialog"

// Every popup a student ACTION can open, in one host. Each is redux-driven and
// renders null while its slot is empty, so mounting the whole set is free — and
// it means any surface that offers the student actions can host them with one
// line instead of hand-picking popups (which is how the students page ended up
// able to open only some of them).
function StudentActionPopups() {
  return (
    <>
      <EditStudentDetailsPopup />
      <EditStudentMentorPopup />
      <EditStudentCareerSuccessAdvisorPopup />
      <EditStudentDatacampCredentialsPopup />
      <ProgramTransferStudentPopup />
      <ClassTransferStudentPopup />
      <EditRegistrationLanguagePopup />
      <RegisterStudentToCourseClassPopup />
      <UnregisterStudentFromCourseClassPopup />
      <UnlockNextWeekPopup />
      <EditUserFeatureFlagsDialog />
      <OffboardStudentPopup />
    </>
  )
}

export default StudentActionPopups
